"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { useTransition } from "react";

export function Select({
  paramName,
  val,
  id,
  disabled,
  hasParam,
  className,
  children,
}: {
  paramName: string;
  val: string;
  id: string;
  disabled: boolean;
  hasParam: boolean;
  className?: string;
  children: React.ReactNode;
}) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const [isPending, startTransition] = useTransition();

  const handleUrl = (e: React.ChangeEvent<HTMLSelectElement>) => {
    startTransition(() => {
      const params = new URLSearchParams(searchParams.toString());
      params.set(paramName, String(e.target.value));
      router.replace("?" + params.toString(), { scroll: false });
    });
  };
  return (
    <select
      className={`${hasParam ? "select-accent" : "select-secondary"} ${
        isPending && "skeleton rounded-md bg-gray-500/80"
      } select ${className || "select-sm w-full max-w-xs"}`}
      id={id}
      value={val}
      onChange={handleUrl}
      aria-label={paramName}
      disabled={disabled}
    >
      {children}
    </select>
  );
}
